import React from "react";
import { Helmet } from "react-helmet";

const HelmetComponent = ({ title, name, content }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name={name} content={content} />
      <meta
        name="keywords"
        content="Cab, Taxi, Call Taxi, Driver, Rapido, Ola, Uber"
      />
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="English" />
      <link rel="canonical" href="https://ssskovaitravels.in/" /> 
    </Helmet>
  );
};

export default HelmetComponent;
